import { ApiResponse, httpClient } from '@/services/client/http-client'
import type {
  ProductSearchResponse,
  ProductSearchResponseStupid,
} from '@/types/product'
import { ProductFormatter } from '../formatter/__f.product'

export const __cSearchService = {
  searchProducts: async (keyword: string) => {
    const response = await httpClient.V4_NEW.get<
      ApiResponse<ProductSearchResponse>
    >(`/products/home-search`, {
      params: {
        home_search: 1,
        limit: 4,
        page: 1,
        sort: 'created_at',
        keyword,
      },
    })
    return response.data
  },

  spotlightSearch: async (params: {
    keyword: string
    page: number
    category?: string
    limit?: number
  }) => {
    //TODO: Đoạn này type định nghĩa lwowfi quas, ranh thi sua
    const response = await httpClient.V4_NEW.get<
      ApiResponse<ProductSearchResponseStupid>
    >(`/products/home-search`, {
      params: {
        spotlight_page: true,
        available: true,
        visibility: true,
        exclude_listing: false,
        home_search: 1,
        limit: params.limit || 20,
        page: params.page,
        keyword: params.keyword,
        category: params.category,
      },
    })

    if (!response.data) {
      return []
    }

    const formattedResponse =
      ProductFormatter.reFormatProductsSpotlightResponse(
        response.data?.products || []
      )

    return {
      data: formattedResponse,
      has_next_page: response.data?.pagination.has_next_page,
    }
  },
}
